import { localStorage } from '@rover/utilities/storage';

/**
 * `'shortlist'` mirrors SHORTLIST_STORAGE_KEY in components/src/shortlist/constants. We
 * don't import that file to avoid a dependency cycle, but there's a drift guard test in
 * components/src/shortlist/constants.test.ts
 */
export const LOGOUT_PRESERVED_KEYS = ['shortlist'];

export const getItem = (key: string): string | null => localStorage.getItem(key);

export const setItem = (key: string, value: string): void => localStorage.setItem(key, value);

export const removeItem = (key: string): void => localStorage.removeItem(key);

export const clear = (): void => localStorage.clear();

/**
 * Clears localStorage on logout while retaining LOGOUT_PRESERVED_KEYS.
 * Iterating from the end avoids re-indexing as `removeItem` shrinks the store.
 */
export const clearOnLogout = (): void => {
  const preserved = new Set(LOGOUT_PRESERVED_KEYS);
  for (let i = localStorage.length - 1; i >= 0; i -= 1) {
    const key = localStorage.key(i);
    if (key !== null && !preserved.has(key)) {
      localStorage.removeItem(key);
    }
  }
};
